/* ---------------------------------------------------------------
   custom-slideshow.js   –   3 枚表示ループ修正版 (v2025-07-03)
   --------------------------------------------------------------- */
   class CustomSlideshow extends HTMLElement {
    connectedCallback () {
      /* ---------- 属性読み込み ---------- */
      this.autoplay = this.bool('autoplay', true);
      this.interval = (+this.getAttribute('interval') || 5) * 1000;
      this.loop     = this.bool('loop', true);
      this.showDots = this.bool('dots', true);
  
      /* ---------- トラック構築 ---------- */
      this.track = Object.assign(document.createElement('div'), { className: 'cs-track' });
      this.track.append(...this.querySelectorAll('.cs-slide'));
      this.prepend(this.track);
  
      /* ---------- ナビゲーション ---------- */
      this.prev = this.nav('prev', '‹');
      this.next = this.nav('next', '›');
      this.append(this.prev, this.next);
  
      /* ---------- メトリクス計算 ---------- */
      this.slides = [...this.track.children];
      this.calcMetrics();
  
      /* ---------- ドット ---------- */
      if (this.showDots) this.makeDots();
  
      /* ---------- イベント ---------- */
      this.prev.onclick = () => this.shift(-1);
      this.next.onclick = () => this.shift( 1);
      this.track.addEventListener('scroll', () =>
        this.debounce(() => this.updateDots(), 40)
      );
      window.addEventListener('resize', () => {
        this.calcMetrics();
        this.updateDots();
      });
  
      /* ---------- Autoplay ---------- */
      if (this.autoplay) {
        this.timer = setInterval(() => this.shift(1), this.interval);
        this.addEventListener('mouseenter', () => clearInterval(this.timer));
        this.addEventListener('mouseleave', () =>
          (this.timer = setInterval(() => this.shift(1), this.interval))
        );
      }
  
      this.updateDots();
    }
  
    /* ====================== ヘルパ ====================== */
    bool (k, d) {
      const v = this.getAttribute(k);
      return v === null ? d : v !== 'false';
    }
  
    nav (dir, label) {
      return Object.assign(document.createElement('button'), {
        className: `cs-nav cs-nav--${dir}`,
        textContent: label
      });
    }
  
    calcMetrics () {
      const gap   = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.padL   = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      this.step   = this.slides[0].getBoundingClientRect().width + gap;
  
      /* ---- 同時表示枚数（perPage）をブレークポイントと同期 ---- */
      this.perPage = window.matchMedia('(min-width: 992px)').matches ? 3 : 1;
    }
  
    currentIndex () {
      return Math.round((this.track.scrollLeft - this.padL) / this.step);
    }
  
    /* ==================== 移動ロジック ==================== */
    shift (dir) {
      const maxStart = this.slides.length - this.perPage; // 左端が置ける最大インデックス
      let idx = this.currentIndex() + dir;
  
      if (this.loop) {
        if (idx > maxStart) idx = 0;          // 末尾 → 先頭
        if (idx < 0)        idx = maxStart;   // 先頭 → 末尾
      } else {
        idx = Math.max(0, Math.min(maxStart, idx));
      }
      this.goTo(idx);
    }
  
    goTo (i) {
      const target = this.padL + i * this.step;
      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }
  
    /* ===================== ドット UI ===================== */
    makeDots () {
      this.dotsWrap = Object.assign(document.createElement('div'), { className: 'cs-dots' });
      this.dots = this.slides.map((_, i) => {
        const b = Object.assign(document.createElement('button'), { className: 'cs-dot' });
        b.onclick = () => this.goTo(i);
        this.dotsWrap.append(b);
        return b;
      });
      this.append(this.dotsWrap);
    }
  
    updateDots () {
      if (!this.showDots) return;
      const idx = this.currentIndex();
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }
  
    /* ---------------- util: debounce ---------------- */
    debounce (fn, ms) {
      clearTimeout(this._t);
      this._t = setTimeout(fn, ms);
    }
  }
  
  customElements.define('custom-slideshow', CustomSlideshow);
  